import apis from "../../utils/apis";
import { Dispatch } from 'redux';
import { RootState } from "..";
import { showFeedbackModal } from "./UserFeedbackActions";
import { CLEAR_TOKEN, FORGOT_PASSWORD, SET_QR_CODE, SET_TOKEN, SET_USER_MENUS } from "../types";
import { handleApiError } from "./utils/utils";
import { clearUserKey } from "../../components/MessageCenter/keyManagement";
import { translate } from '../../i18n/translate';

export const setToken = (token: string | null, userId: string | null) => {
  return {
    type: SET_TOKEN,
    token,
    userId
  };
};

export const clearToken = () => {
  return {
    type: CLEAR_TOKEN,
  };
};

export const newPasswordToken = (uuid: string | null) => {
  return {
    type: FORGOT_PASSWORD,
    uuid
  }
}

export const setQrCode = (qr: string | null) => {
  return {
    type: SET_QR_CODE,
    qr
  }
}
export interface ErrorResponse {
  message: string;
  error?: string
}

export const setOtpErrorMessage = (message: string) => ({
  type: 'SET_OTP_ERROR_MESSAGE',
  payload: message,
});

export const signOut = () => {
  return async (dispatch: Dispatch<any>, getState: () => RootState) => {
    try {
      const userUID = getState().user.userInfo?.UserUID;

      if (userUID) {
        clearUserKey(userUID);
      }


      localStorage.clear();
      sessionStorage.clear();

      if ('caches' in window) {
        const names = await caches.keys();
        await Promise.all(names.map(n => caches.delete(n)));
      }

      dispatch(showFeedbackModal({
        showModal: true,
        message: translate("Logged out"),
        modalType: 'success',
        duration: 3000
      }));

    } catch (err) {
      handleApiError(err, dispatch);
    }
  };
};
export const setTutorialCompletedAction = (completed: boolean) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await apis({
        method: 'POST',
        url: '/user/tutorialCompleted',
        data: { tutorialCompleted: completed },
      });

      if (response.status === 200) {
        dispatch({
          type: 'SET_TUTORIAL_COMPLETED',
          payload: completed,
        });

        let tokenString = sessionStorage.getItem('token') || localStorage.getItem('token');
        if (tokenString) {
          const userData = JSON.parse(tokenString);
          userData.tutorialCompleted = completed;
          sessionStorage.getItem('token')
            ? sessionStorage.setItem('token', JSON.stringify(userData))
            : localStorage.setItem('token', JSON.stringify(userData));
        }
      } else {
        handleApiError(response, dispatch)
      }
    } catch (error) {
      handleApiError(error, dispatch)
    }
  };
};



export const fetchUserMenus = () => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response: any = await apis({
        method: 'GET',
        url: '/user/menu'
      });

      if (response && response.status === 200) {
        const menus = response.data.menus;
        dispatch({ type: SET_USER_MENUS, menus });
      } else {
        handleApiError(response, dispatch);
      }
    } catch (error) {
      handleApiError(error, dispatch);
    }
  };
};
